<template>
  <div class="container" style="background:var(--bg3);">
    待分配项目
    <div>待关联</div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
